import { QueryClient } from '@tanstack/react-query';

export const organizationListQueryKey = 'organizations';

export const invalidateOrganizationListQuery = (queryClient: QueryClient) => {
  return queryClient.invalidateQueries({
    predicate: (query) => query.queryKey[0] === organizationListQueryKey,
  });
};
